import axios from 'axios'
import {API_ADMIN} from '@/utils/constants/Api'
import { IFilter } from '@/utils/interfaces/FilterInterface';
import { DashboardAverageTicketModel } from '@/dashboard/models/DashboardAverageTicketModel'
import { DashboardAmountOfSalesModel } from '@/dashboard/models/DashboardAmountOfSalesModel'
import { DashboardAmountOfMoneyEarnedModel } from '@/dashboard/models/DashboardAmountOfMoneyEarnedModel'
import { DashboardPendingOrderModel } from '@/dashboard/models/DashboardPendingOrderModel';
import { ISalesPeak } from '../interfaces/SalesPeakInterface';
import {orderBy} from 'lodash'
import { DashboardPendingOrderStatusModel } from '../models/DashboardPendingOrderStatusModel';
import { DashboardPendingOrderIntegrationBackendModel } from '../models/DashboardPendingOrderIntegrationBackendModel';
import { flattenTree, TreeNode } from '../../utils/normalizers/TreeNormalizer';

export type DashboardGroupBy = 'channel' | 'store'

export interface IDashboardAmountGroup<T> {
    id: number
    list: T[]
}

function withGroupBy(filter:IFilter, groupBy:DashboardGroupBy):string {
    const queryString = filter.toQueryString()

    return `${queryString}${queryString ? '&' : '?'}groupBy=${groupBy}`
}

export default {
    getPendingOrders():Promise<DashboardPendingOrderModel[]> {
        return axios.get(`${API_ADMIN}dashboard/pending_orders_date_range`)
            .then(({data}) => {
                return orderBy(data.map((d:DashboardPendingOrderModel) => {
                    return new DashboardPendingOrderModel(d);
                }), 'end', 'desc');
            });
    },
    getPendingOrdersIntegrationBackend():Promise<DashboardPendingOrderModel[]> {
        return axios.get(`${API_ADMIN}dashboard/pending_orders_backend`)
            .then(({data}) => {
                return orderBy(data.map((d:DashboardPendingOrderIntegrationBackendModel) => {
                    return new DashboardPendingOrderIntegrationBackendModel(d);
                }), 'end', 'desc');
            });
    },
    getPendingOrdersStatus():Promise<DashboardPendingOrderStatusModel[]> {
        return axios.get(`${API_ADMIN}dashboard/pending_orders_status`)
            .then(({data}) => {
                return data.map((d:DashboardPendingOrderStatusModel) => {
                    return new DashboardPendingOrderStatusModel(d);
                });
            });
    },
    getSalesPeak(filter:IFilter):Promise<ISalesPeak[]> {
        return axios.get(`${API_ADMIN}dashboard/sales_peak${filter.toQueryString()}`)
            .then(({data}) => {
                return data;
            });
    },
    getAverageTicket(filter:IFilter):Promise<DashboardAverageTicketModel[]> {
        return axios.get(`${API_ADMIN}dashboard/average_ticket${filter.toQueryString()}`)
            .then(({data}) => {
                return data.map((d:Partial<DashboardAverageTicketModel>) => {
                    return new DashboardAverageTicketModel(d);
                });
            });
    },
    getAmountOfSales(filter:IFilter):Promise<DashboardAmountOfSalesModel[]> {
        return axios.get(`${API_ADMIN}dashboard/amount_quantity_sales${filter.toQueryString()}`)
            .then(({data}) => {
                return data.map((d:DashboardAmountOfSalesModel) => {
                    return new DashboardAmountOfSalesModel(d);
                });
            });
    },
    getAmountOfMoneyEarned(filter:IFilter):Promise<DashboardAmountOfMoneyEarnedModel[]> {
        return axios.get(`${API_ADMIN}dashboard/amount_money_earned${filter.toQueryString()}`)
            .then(({data}) => {
                return data.map((d:DashboardAmountOfMoneyEarnedModel) => {
                    return new DashboardAmountOfMoneyEarnedModel(d);
                });
            });
    },
    getAmountOfMoneyEarnedGrouped(filter:IFilter, groupBy:DashboardGroupBy):Promise<Array<IDashboardAmountGroup<DashboardAmountOfMoneyEarnedModel>>> {
        return axios.get(`${API_ADMIN}dashboard/amount_money_earned_grouped${withGroupBy(filter, groupBy)}`)
            .then(({data}) => {
                return data.map((g:IDashboardAmountGroup<DashboardAmountOfMoneyEarnedModel>) => ({
                    id: g.id,
                    list: (g.list || []).map((d) => new DashboardAmountOfMoneyEarnedModel(d)),
                }));
            });
    },
    getAmountOfSalesGrouped(filter:IFilter, groupBy:DashboardGroupBy):Promise<Array<IDashboardAmountGroup<DashboardAmountOfSalesModel>>> {
        return axios.get(`${API_ADMIN}dashboard/amount_quantity_sales_grouped${withGroupBy(filter, groupBy)}`)
            .then(({data}) => {
                return data.map((g:IDashboardAmountGroup<DashboardAmountOfSalesModel>) => ({
                    id: g.id,
                    list: (g.list || []).map((d) => new DashboardAmountOfSalesModel(d)),
                }));
            });
    },
    getCategoryAmountQuantitySales(filter:IFilter):Promise<TreeNode[]> {
        return axios.get(`${API_ADMIN}dashboard/category_amount_quantity_sales${filter.toQueryString()}`)
            .then(({data}) => {                
                return flattenTree(data);
            })
    },
    getCategoryAmountMoneySales(filter:IFilter):Promise<TreeNode[]> {
        return axios.get(`${API_ADMIN}dashboard/category_amount_money_sales${filter.toQueryString()}`)
            .then(({data}) => {
                return flattenTree(data);
            })
    },
    getRegionAmountQuantitySales(filter:IFilter):Promise<TreeNode[]> {
        return axios.get(`${API_ADMIN}dashboard/region_amount_quantity_sales${filter.toQueryString()}`)
            .then(({data}) => {
                return flattenTree(data);
            })
    },
    getRegionAmountMoneySales(filter:IFilter):Promise<TreeNode[]> {
        return axios.get(`${API_ADMIN}dashboard/region_amount_money_sales${filter.toQueryString()}`)
            .then(({data}) => {
                return flattenTree(data);
            })
    },
}
